var $1c3a516362553e04$exports = {};
const $1c3a516362553e04$var$header = document.querySelector(".header");
window.addEventListener("scroll", ()=>{
    if (window.scrollY > 40) $1c3a516362553e04$var$header.classList.add("scrolled");
    else $1c3a516362553e04$var$header.classList.remove("scrolled");
});
const $1c3a516362553e04$var$experienceItems = document.querySelectorAll(".works__item");
$1c3a516362553e04$var$experienceItems.forEach((item)=>{
    const button = item.querySelector(".works__button");
    button.addEventListener("click", ()=>{
        const isActive = item.classList.contains("active");
        $1c3a516362553e04$var$experienceItems.forEach((el)=>{
            el.classList.remove("active");
        });
        if (!isActive) item.classList.add("active");
    });
});
const $1c3a516362553e04$var$footer = document.querySelector(".footer");
// Только устройства с сенсорным экраном (iPhone, Android, iPad)
const $1c3a516362553e04$var$isTouchDevice = window.matchMedia("(pointer: coarse)").matches;
if ($1c3a516362553e04$var$footer && $1c3a516362553e04$var$isTouchDevice) {
    function updateBackground() {
        const rect = $1c3a516362553e04$var$footer.getBoundingClientRect();
        // Если верх футера находится в пределах экрана,
        // делаем фон body черным.
        const isFooterVisible = rect.top < window.innerHeight;
        document.body.classList.toggle("footer-visible", isFooterVisible);
    }
    window.addEventListener("scroll", updateBackground, {
        passive: true
    });
    window.addEventListener("resize", updateBackground);
    updateBackground();
}


//# sourceMappingURL=frontend.e06837e3.js.map
